import { useTheme } from '@material-ui/core/styles';
import React, { useState, useEffect } from 'react';
import AceEditor from "react-ace";
import { debounce } from 'debounce';

interface Props {
  workflow: any;
  onWorkflowChange: (workflow: any) => void;
}

function createSanitizedWorkflow(workflow) {
  const wf = { ...workflow };
  delete wf.Versions;
  delete wf.Archived;
  delete wf.GUID;
  delete wf.Family;
  delete wf.LastExecutionTime;
  delete wf.LastExecutionGUID;
  delete wf.WorkflowStatus;
  delete wf.LastModified;
  delete wf.Teardown;
  delete wf.NotificationTopicARN;
  return wf;
}

function WorkflowJsonTab(props: Props) {
  const { workflow, onWorkflowChange } = props;
  const [editorJson, setEditorJson] = useState(JSON.stringify(createSanitizedWorkflow(workflow), null, 2));
  const theme = useTheme();

  function onJsonChange(newValue) {
    setEditorJson(newValue);
    try {
      const newWorkflow = JSON.parse(newValue);
      onWorkflowChange(newWorkflow);
    } catch (error) {
      console.log('Failed to parse editor json');
    }
  }

  const debouncedOnJsonChange = debounce(onJsonChange, 500);

  useEffect(() => {
    return () => debouncedOnJsonChange.flush();
  }, [debouncedOnJsonChange]);

  return (
    <div>
      <AceEditor
        mode="json"
        theme={theme.palette.type === 'light' ? 'github' : 'monokai'}
        width="100%"
        maxLines={Infinity}
        value={editorJson}
        onChange={debouncedOnJsonChange}
        name="workflow-json-model"
        setOptions={{ useWorker: false }}
        showPrintMargin={false}
        editorProps={{ $blockScrolling: true }}
      />
    </div >
  );
};

export default WorkflowJsonTab;
